// extracted by mini-css-extract-plugin
export default {"wrapper":"JobAlertModal_wrapper__6K6Mb"};